import {useMinSpin} from "../hooks/useMinSpin";
import { Routes } from "./index";
import PrivateRoute from "./PrivateRoute";
import {PATHS} from "./utils/Paths.links";
import {Switch, Redirect} from "react-router-dom";
import {useEffect, useState} from "react";
import {useUserStore} from "../../modules/shop/user/store";
import PageLoader from "../shared/PageLoader/PageLoader";

const AppRouter = () => {
    const [isLoading, setIsLoading] = useState(true); // Флаг загрузки данных
    // лоадер видно щонайменше пів секунди (useMinSpin)
    const showLoader = useMinSpin(isLoading);

    const user = useUserStore((state) => state.user);       // Текущее состояние пользователя
    const fetchUser = useUserStore((state) => state.fetchUser); // Функция загрузки пользователя

    // Авторизація береться прямо зі стану користувача (без окремого стейта й ефекту):
    // коли завантаження завершується, маршрути одразу бачать актуальне значення,
    // тому штучна пауза більше не потрібна, а закриті сторінки не редіректять гостей помилково
    const isAuthenticated = !!user?.steamId;

    useEffect(() => {
        let cancelled = false;

        const initializeAuth = async () => {
            try {
                await fetchUser(); // Ждем загрузку данных пользователя с бэка
            } catch (error) {
                console.error("Ошибка при получении пользователя:", error);
            } finally {
                if (!cancelled) {
                    setIsLoading(false); // Завершаем состояние загрузки одразу, без зайвих пауз
                }
            }
        };

        initializeAuth();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <>
            {
                showLoader
                    ? <PageLoader size="lg" fullscreen label="ASKOLD" />
                    : <Switch>
                        { Routes.map((route) =>
                            <PrivateRoute
                                {...route}
                                token={isAuthenticated}
                                key={route.path}
                            />
                        )}
                        <Redirect to={PATHS.SHOP} />
                    </Switch>
            }
        </>
    )
};

export default AppRouter;
